import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import moment from 'moment';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { ICONS } from '../../resources/icons';

@Component({
  standalone: false,
  selector: 'nimbus-calendar-day-header',
  templateUrl: './calendar-day-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarDayHeaderComponent {
  @Output() public dateChange = new EventEmitter<Date>();

  public selectedDate = new Date();

  public ICONS = ICONS;
  public TranslationKeys = TranslationKeys;

  public onToday(): void {
    this.selectedDate = new Date();
    this.dateChange.emit(this.selectedDate);
  }

  public previousDay(): void {
    this.selectedDate = moment(this.selectedDate).subtract(1, 'day').toDate();
    this.dateChange.emit(this.selectedDate);
  }

  public nextDay(): void {
    this.selectedDate = moment(this.selectedDate).add(1, 'day').toDate();
    this.dateChange.emit(this.selectedDate);
  }
}
